import { Component, OnInit } from '@angular/core';
import { UserService } from './user/user.service';
import { PublisherService } from './publisher/publisher.service';
import { Message } from './publisher/message';
import { Subject } from 'rxjs/Subject';
import {ActivatedRoute, NavigationEnd, Router} from '@angular/router';
import {HeaderService} from './headerfooter/header.service';

@Component({
    selector: 'app',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
    private clickedOutsideChannel: Subject<Message>;
    currentRoute: string = '/';


    constructor(private userService: UserService, private pubService: PublisherService, private router: Router ,private route: ActivatedRoute) {
        this.router.events.subscribe(
            (event) => {
                if (event instanceof NavigationEnd ) {
                    this.currentRoute = event.url;
                }
            });

    }

    ngOnInit() {
        this.clickedOutsideChannel = this.pubService.createChannel('clicked-outside');
        this.userService.updateFromStorage();
    }

    isLoggedIn(): boolean {
        return this.userService.isLoggedIn();
    }

    onClicked() {
        this.clickedOutsideChannel.next(new Message('clicked-outside'));
    }
}


// WEBPACK FOOTER //
// ./src/app/app.component.ts